import { render, staticRenderFns } from "./ContinueOrder.vue?vue&type=template&id=84cd4ffc&scoped=true"
import script from "./ContinueOrder.vue?vue&type=script&lang=js"
export * from "./ContinueOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cd4ffc",
  null
  
)

export default component.exports